import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Motif from './Motifs';
import { sectionFor } from './sections';

/**
 * Section header: title, live subtitle, one-line description of the section, page actions,
 * and the animated illustration of that section. Replaces the old .page-header.
 */
export default function SectionHero({ title, subtitle, children }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const sec = sectionFor(pathname);
  return (
    <section className="hero" style={{ '--sec': sec.accent }}>
      <div className="hero-membrane" aria-hidden="true"><i /><i /><i /></div>
      <div className="hero-text">
        <h1 className="hero-title">{title}</h1>
        <p className="hero-desc">{t('hero_' + sec.key)}</p>
        {subtitle ? <p className="hero-sub">{subtitle}</p> : null}
      </div>
      <div className="hero-art"><Motif section={sec.key} /></div>
      {children ? <div className="hero-actions">{children}</div> : null}
    </section>
  );
}
